export default function onTab(): void {
  function handleFirstTab({ keyCode }: KeyboardEvent): void {
    if (keyCode === 9) {
      // user is using tabbing instead of mouse
      document.body.classList.add('user-is-tabbing');
      window.removeEventListener('keydown', handleFirstTab);
    }
  }

  window.addEventListener('keydown', handleFirstTab);
}
